module.exports = __webpack_public_path__ + "80d206e862fc08e7ac094d9f72c5e4c7.pdf";